import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Homepage from './components/Home'; // Adjusted path
import AboutMe from './components/AboutMe'; // Adjusted path
import MarkdownPage from './components/MarkDownPage'; // Adjusted path
import NavBar from './components/NavBar'; // Import NavBar if you want it in App.js
import ProjectOverview from './components/ProjectOverview';

function App() {
    return (
      <div className="App">
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/aboutme" element={<AboutMe />} />
          <Route path="/projects" element={<ProjectOverview />} />
          <Route path="/projects/:projectcategory/:name" element={<MarkdownPage />} />
        </Routes>
      </div>
    );
  }
  
  export default App;